import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { BusinessEventTriggerConfig } from './BusinessEventTriggerConfig';
import {
  BusinessEventTriggerNode,
  businessEventTriggerVisualDefinition,
} from './BusinessEventTriggerNode';
import {
  BusinessEventTriggerConfigType,
  defaultBusinessEventTriggerConfig,
  validateBusinessEventTriggerConfig,
  getBusinessEventTriggerPreviewText,
} from './schema';

export { BusinessEventTriggerNode } from './BusinessEventTriggerNode';
export { BusinessEventTriggerConfig } from './BusinessEventTriggerConfig';
export type { BusinessEventTriggerConfigType } from './schema';

/** Full definition for the registry */
export const businessEventTriggerDefinition: NodeDefinition<BusinessEventTriggerConfigType> =
  {
    ...businessEventTriggerVisualDefinition,
    category: 'trigger',
    NodeComponent: BusinessEventTriggerNode as unknown as React.ComponentType<
      NodeProps<Node<BaseNodeData>>
    >,
    ConfigComponent: BusinessEventTriggerConfig,
    defaultConfig: () => ({ ...defaultBusinessEventTriggerConfig }),
    validateConfig: validateBusinessEventTriggerConfig,
    getPreviewText: getBusinessEventTriggerPreviewText,
  };
